
export default {
    getTipoVagas(state) {
        return state.tipoVagas
    },
    getTipoVaga(state) {
        return state.tipoVaga
    },
}